import * as DocumentPicker from 'expo-document-picker';
import { useEffect, useState } from 'react';

interface UseUploaderProps {
  documentType?: string;
  onDocumentSelected?: (document: DocumentPicker.DocumentResult | undefined) => void;
}
interface UseUploader {
  selectedDocument?: DocumentPicker.DocumentResult;
  pickDocument: () => void;
  removeDocument: () => void;
}

export const useUploader = ({ documentType = '&ast;/*', onDocumentSelected }: UseUploaderProps): UseUploader => {
  const [selectedDocument, setSelectedDocument] = useState<undefined | DocumentPicker.DocumentResult>(undefined);

  useEffect(() => {
    onDocumentSelected && onDocumentSelected(selectedDocument);
  }, [selectedDocument]);

  const pickDocument = async () => {
    if (selectedDocument) return;
    const uploaderResult = await DocumentPicker.getDocumentAsync({
      type: documentType,
      multiple: true,
      copyToCacheDirectory: true
    });

    setSelectedDocument(uploaderResult);
  };

  const removeDocument = () => {
    setSelectedDocument(undefined);
  };

  return {
    selectedDocument,
    pickDocument,
    removeDocument
  };
};
